module.exports = __webpack_public_path__ + "f2e406d7c289e6980ce85667bc76fd0c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/arrow-left.svg
// module id = 728
// module chunks = 0